// extracted by mini-css-extract-plugin
var _1 = "FilePreviewErrorTooltipText-moduleFilePreviewErrorTooltipText__yDHZE FloatingTooltipContentText-moduleFloatingTooltipContentText__SS1TQ";
var _2 = "FilePreviewErrorTooltipText-moduleadditionalText__yUqlr FloatingTooltipContentText-moduleadditionalText__yxASO";
var _3 = "FilePreviewErrorTooltipText-moduletext__mF1mw FloatingTooltipContentText-moduletext__OMqYx";
export { _1 as "FilePreviewErrorTooltipText", _2 as "additionalText", _3 as "text" }
